//[shopify domain]/browsing_context_suggestions.json
// Redirect

if (!Shopify.designMode) {
    (function () {

        function getCookie(name) {
            const nameEQ = name + "=";
            let ca = document.cookie.split(';');
            for(let i=0;i < ca.length;i++) {
                let c = ca[i];
                while (c.charAt(0)==' ') c = c.substring(1,c.length);
                if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
            }
            return null;
        }

        function httpGet(theUrl){
            const xmlHttp = new XMLHttpRequest();
            xmlHttp.open( "GET", theUrl, false ); // false for synchronous request
            xmlHttp.send( null );
            return xmlHttp.responseText;
        }

        const data = httpGet("/browsing_context_suggestions.json")
        let country = JSON.parse(data).detected_values.country;
        const auGroup = ['Australia','United Kingdom', 'Singapore', 'Ireland', 'New Zealand', 'France', 'Germany', 'Netherlands', 'Spain', 'Switzerland', 'Canada', 'Hong Kong', 'Indonesia', 'Belgium', 'Denmark', 'Finland', 'Italy', 'Poland', 'Sweden', 'China', 'Portugal'];
        const usGroup = ['United States']
        let store = Shopify.shop;
        let pathName = '';
        
            pathName = window.location.pathname;
        

        let otherStore = {}

        function openPopup() {
            const redirectPopup = document.querySelector("#redirect-popup")
            redirectPopup.innerHTML= redirectPopup.innerHTML.replaceAll('{other_store_name}', otherStore.name).replaceAll('{other_store_currency}', otherStore.currency).replaceAll('{other_store_url}', otherStore.url)
            redirectPopup.classList.remove("hidden");
        }

        function checkGEOLocation() {
            if (availableCountries.includes(country.name)) {
                if (store == "aire-shades.myshopify.com") {
                otherStore.name = country.name
                otherStore.currency = 'USD'
                otherStore.url = 'http://aire-shades-usd.myshopify.com/?redirect=false'
                // check if the user is not from AU and NZ
                if (usGroup.includes(country.name)) {
                    openPopup();
                }
            }
                // Visiting US store
                if (store == "aire-shades-usd.myshopify.com") {
                    otherStore.name = country.name
                    otherStore.currency = 'AUD'
                    otherStore.url = 'http://aire-shades.myshopify.com/?redirect=false'
                    // check if customers is from AU and NZ
                    if (auGroup.includes(country.name)) {
                        openPopup();
                    }
                }
            } else {
              // Visiting US store
              if (store == "aire-shades-usd.myshopify.com") {
                  otherStore.name = country.name
                  otherStore.currency = 'AUD'
                  otherStore.url = 'http://aire-shades.myshopify.com/?redirect=false'
                  // check if customers is from AU and NZ
                  if (auGroup.includes(country.name)) {
                      openPopup();
                  }
              }
            }
        }

        const url = new URL(location)
        if (url.searchParams.get('redirect') == 'false') {
            setCookie('redirect', 'true', 999999)
            url.searchParams.delete('redirect')
            history.replaceState({}, '', url)
        }

        const cookieRedirect = getCookie('redirect');

        if(!cookieRedirect && cookieRedirect != true) {
            checkGEOLocation();
        }

    })()

    function setCookie(name,value,days) {
        let expires = "";
        if (days) {
            let date = new Date();
            date.setTime(date.getTime() + (days*24*60*60*1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "")  + expires + "; path=/";
    }

    function closePopup() {
        document.querySelector("#redirect-popup").classList.add("hidden");
        setCookie('redirect', 'true', 999999)
    }

    // Clicking outside the popup will close popup on desktop
    function clickOutside(event, el) {
        if (event.target == el && window.innerWidth > 990) {
            closePopup()
        }
    }
}